module.exports = __webpack_public_path__ + "static/media/img-made-thumb@2x.e069ed44.png";